/**
 * Formatação de exibição (pt-BR). Separada da regra para que o cálculo
 * continue puro e em centavos — a UI formata, nunca arredonda dado.
 */
import type { Kpi } from "./dashboard/kpis.js";

export function formatBrl(cents: number): string {
  return (cents / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function formatPercent(value: number): string {
  return `${value.toLocaleString("pt-BR", { maximumFractionDigits: 2 })}%`;
}

export function formatCount(value: number): string {
  return value.toLocaleString("pt-BR");
}

export function formatDateTime(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
}

/** Valor do KPI já formatado. Ausência de dado é "—", nunca 0. */
export function formatKpiValue(kpi: Kpi): string {
  if (kpi.value === null) return "—";
  if (kpi.format === "currency") return formatBrl(kpi.value);
  if (kpi.format === "percent") return formatPercent(kpi.value);
  return formatCount(kpi.value);
}

export function formatOrderStatus(status: string): string {
  const labels: Record<string, string> = {
    paid: "Pago",
    awaiting_payment: "Aguardando pagamento",
    awaiting_shipping_quote: "Aguardando cotação de frete",
    payment_failed: "Pagamento recusado"
  };
  return labels[status] ?? status;
}

export function formatMarginStatus(status: string): string {
  const labels: Record<string, string> = {
    ok: "Dentro do piso",
    below_target: "Abaixo do piso",
    missing_cost: "Custo não sincronizado",
    no_offer: "Sem oferta vigente"
  };
  return labels[status] ?? status;
}

/** Canal exibido ao operador. O fornecedor de WhatsApp é "WAPI da TDZAIN". */
export function formatChannel(channel: string): string {
  const labels: Record<string, string> = {
    whatsapp: "WhatsApp (WAPI da TDZAIN)",
    web: "Web chat",
    webchat: "Web chat"
  };
  return labels[channel] ?? channel;
}
